export default /* html */ `
<span class="icon material-symbols-outlined" *bind:class="{ loading: loading }">{{icon}}</span>
`
